import { Events } from '../events/events.js';
import Util from '../util.js';
export class Content {
  self = null;
  lastVersion = 0;
  lastCountry = 0;
  staticContentUrl = '';
  brand = '';
  cacheContent = Array();
  cacheTeams = Array();
  cacheTournaments = Array();
  cachePrices = Array();
  cacheDataObject = null;
  available = false;

  integer_fields = [
    'id',
    'team_1',
    'team_2',
    'tournament',
    'updated',
    'date',
    'date_ends',
    'date_server_spawns',
    'date_server_goes_live',
    'status',
    'type',
    'signal_ready',
    'product_id',
    'weight',
    'archived',
    'lineal'
  ];


  constructor(brand, _this) {
    this.self = _this;
    this.brand = brand;

    // Si nuestra url es de desarrollo, usamos la url de desarrollo
    if (location.href.includes('127.0.0') || location.href.includes('192.168')) {
      this.staticContentUrl = 'https://beta.basquetpass.tv/';
    } else {
      //this.staticContentUrl = 'https://static.tbcast.com/' + brand + '/';
      this.staticContentUrl = 'https://static.tbcast.com/';
    }

    // Cargamos la caché
    this.loadCache();
  }

  async refresh(options = { force: true }) {
    this.getAllData(options);
  }

  /**
 * Consulta actualizaciones de contenido a la plataforma
 *
 * @param {function} [onDone=null] Callback de terminado
 * @return 
 */
  async getAllData(options = { force: false }) {
    var force = options.force;

    // Si tenemos this.cacheDataObject y no viene force, lo devolvemos
    if (this.cacheDataObject && !force) {
      return this.cacheDataObject;
    }

    // Recuperamos el usuario para sacar el país
    let user = await this.self.user.getUser();

    try {
      // Comprobamos si hay cambios en el contenido
      var ver = await fetch(this.staticContentUrl + 'content_date.txt?' + Math.random());
      var data = await ver.text();
      data = Number.parseInt(data);
      if (data == this.lastVersion && this.lastCountry == user.isocode.country_num) { // Si no hay cambios, devolvemos el cache

        // Si tenemos this.cacheDataObject, lo devolvemos
        if (this.cacheDataObject) {
          return this.cacheDataObject;
        }
      }
    } catch (error) {
      console.error('[Content] Error: ', error);
      // Si tenemos this.cacheDataObject, lo devolvemos
      if (this.cacheDataObject) {
        return this.cacheDataObject;
      }
      return;
    }

    var jsonUrl = this.staticContentUrl + 'content_' + user.ui_code + '_' + user.ui_code + '.json';

    try {
      var data = await fetch(jsonUrl + '?' + Math.random());
      var data = await data.json();
    } catch (error) {
      console.error('[Content] Error: ', error);
      return;
    }

    this.cacheDataObject = data;

    content_ui_code_loaded = user.ui_code;
    localStorage.setItem('content_ui_code_loaded', content_ui_code_loaded);

    //Si tournaments nos llega en objeto, lo convertimos a array si no lo es
    if (data.d.tournaments && !Array.isArray(data.d.tournaments)) {
      var tournaments = [];
      for (var key in data.d.tournaments) {
        tournaments.push(data.d.tournaments[key]);
      }
      data.d.tournaments = tournaments;
    }

    // Convertimos los valores numéricos a enteros
    data = this.self.parseIntegerFields(data, this.integer_fields);

    data.d.teams.forEach(item => {
      item.id = parseInt(item.id);
      item.selectable = parseInt(item.selectable);
      item.updated = parseInt(item.updated);
    });

    data.d.tournaments.forEach(item => {
      item.id = parseInt(item.id);
      item.updated = parseInt(item.updated);
    });

    // Si country ha cambiado, limpiamos el cache
    if (this.lastCountry != user.isocode.country_num) {
      this.cacheContent = [];
      this.cacheTeams = [];
      this.cacheTournaments = [];
      this.cachePrices = [];
    }

    // Actualizamos el cache
    this.cacheAddData(data, { remove: true });

    this.lastVersion = parseInt(data.v);
    this.lastCountry = user.isocode.country_num;

    localStorage.setItem(this.brand + "lastContentData", JSON.stringify({ country: this.lastCountry, v: this.lastVersion, d: data.d }));

    this.available = true
    this.self.emit(Events.CONTENT_UPDATE, data);

    return data;
  }

  async loadCache() {
    var data = localStorage.getItem(this.brand + "lastContentData");
    if (data) {
      try {
        data = JSON.parse(data);
        this.cacheDataObject = data;
        this.lastCountry = data.country;
        this.lastVersion = data.v;
        this.cacheAddData(data);

        // Le ponemos un Timer porque la clase todavía no se ha generado
        setTimeout(() => {
          // Disparamos el evento de contenido disponible
          this.available = true;
          this.self.emit(Events.CONTENT_UPDATE, data);
          
        }, 100);

      } catch (error) {
        console.error('[Content] Error: ', error);
      }
    }
  }

  /**
 * Función que añade o actualiza un contenido en el cache
 *
 * @param {*} data Objeto de respuesta con el contenido
 * @param {boolean} [remove=false] Si es true, elimina el contenido del cache si no está en la respuesta
 * @returns Objeto con los valores que han cambiado
 */
  cacheAddData(data, options = { remove: false }) {
    var remove = options.remove;

    var ret = {
      "prices": false,
      "teams": false,
      "tournaments": false,
      "content": false
    };

    var updated = false;


    // Recorremos los precios
    data.d.prices && data.d.prices.forEach(price => {

      try {
        // Sincronizamos los precios
        updated = this._syncObjectInArrayObjects(this.cachePrices, price);
        if (updated && !ret.prices) {
          ret.prices = true;
        }
      } catch (e) {
        debugger;
        console.log(e);
      }
    });

    if (remove) { // Borramos los equipos que no estén en la respuesta
      updated = this._removeNotInArrayObjects(this.cachePrices, data.d.prices);
      if (updated && !ret.prices) {
        ret.prices = true;
      }
    }



    // Recorremos los equipos
    data.d.teams && data.d.teams.forEach(team => {

      try {

        // Sincronizamos los equipos
        updated = this._syncObjectInArrayObjects(this.cacheTeams, team);
        if (updated && !ret.teams) {
          ret.teams = true;
        }
      } catch (e) {
        debugger;
        console.log(e);
      }
    });

    if (remove) { // Borramos los equipos que no estén en la respuesta
      updated = this._removeNotInArrayObjects(this.cacheTeams, data.d.teams);
      if (updated && !ret.teams) {
        ret.teams = true;
      }
    }

    //Tournaments puede estar en objetos en vez de array, lo convertimos a array
    if (data.d.tournaments && !Array.isArray(data.d.tournaments)) {
      data.d.tournaments = Object.values(data.d.tournaments);
    }

    // Recorremos los torneos
    data.d.tournaments && data.d.tournaments.forEach(tournament => {

      try {

        // Sincronizamos los torneos
        updated = this._syncObjectInArrayObjects(this.cacheTournaments, tournament);
        if (updated && !ret.tournaments) {
          ret.tournaments = true;
        }
      } catch (e) {
        debugger;
        console.log(e);
      }
    });

    if (remove) { // Borramos los torneos que no estén en la respuesta
      updated = this._removeNotInArrayObjects(this.cacheTournaments, data.d.tournaments);
      if (updated && !ret.tournaments) {
        ret.tournaments = true;
      }
    }


    // Solo es uno
    if (data.d.content.id) {
      data.d.content = [data.d.content];
    }

    // Recorremos los contenidos
    for (var i = 0; i < data.d.content.length; i++) {

      try {
        // Sincronizamos los contenidos
        updated = this._syncObjectInArrayObjects(this.cacheContent, data.d.content[i]);

        if (updated && !ret.content) {
          ret.content = true;
        }
      } catch (e) {
        debugger;
        console.log(e);
      }
    }

    if (remove) { // Borramos los contenidos que no estén en la respuesta
      updated = this._removeNotInArrayObjects(this.cacheContent, data.d.content);
      if (updated && !ret.content) {
        ret.content = true;
      }
    }


    return ret;

  }


  getAllTeams() {
    return this.cacheTeams;
  }


  getTeam(id) {
    id = Number.parseInt(id);
    var team = this.cacheTeams.find(o => o.id == id);

    // Miramos que haya color
    if (team && team.color == null) {
      team.color = "#000000";
    }

    return this.cacheTeams.find(o => o.id == id);
  }

  getTeamName(id) {
    id = Number.parseInt(id);
    var a = this.cacheTeams.find(o => o.id == id);
    if (a) {
      return a.short_name;
    }
    return "";
  }

  getAllTournaments() {
    return this.cacheTournaments;
  }

  getTournament(id) {
    id = Number.parseInt(id);
    return this.cacheTournaments.find(o => o.id == id);
  }

  /**
   * Devuelve todo el contenido disponible
   *
   * @return 
   * @memberof Content
   */
  async getAllContent() {
    var data = await this.getAllData();
    return data.d.content;
  }


  /**
   * Busca en la caché el id pasado en la caché, y si no lo encuentra, lo pide al servidor
   *
   * @param {*} id 
   * @returns {Promise<Object>} El contenido buscado
   */
  async getContent(id) {
    // Buscamos en la caché
    let content = this.cacheContent.find(o => o.id == id);

    if (content) {
      return content;
    }

    // Si no lo encontramos, lo pedimos al servidor	
    try {
      const response = await fetch(this.staticContentUrl + 'data/content/content_' + id + '.json?' + Math.random());
      if (!response.ok) {
        console.error('[Content] Error:', response);
        return null;
      }
      const data = await response.json();

      try {
        // Si lleva equipos, los añadimos
        if (data.d.content.team_1_populated) {
          data.d.teams = [];
          data.d.teams.push(data.d.content.team_1_populated);
          data.d.teams.push(data.d.content.team_2_populated);
        }

        this.cacheAddData(data);
      } catch (e) {
        debugger;
      }

      return data.d.content[0];

    } catch (error) {
      console.error('[Content] Error:', error);
      return null;
    }
  }


  /**
   * Busca un objecto y lo compara con otro y si son diferentes los sincroniza
   *
   * @param {*} arrayObjects 
   * @param {*} object2 
   * @return boolean true si se ha sincronizado
   */
  _syncObjectInArrayObjects(arrayObjects, object) {

    for (var i = 0; i < arrayObjects.length; i++) {

      if (arrayObjects[i].id == object.id) {
        if (Util.equalObjects(arrayObjects[i], object)) {
          arrayObjects[i] = object;
          return true;
        } else {
          return false;
        }
      }
    }

    // Si no se ha encontrado el objeto lo añadimos
    arrayObjects.push(object);
    return true;

  }


  /**
   * Borra los elementos del primer array que no estén en el segundo comparando los id
   *
   * @param {*} arrayObjects
   * @param {*} arrayObjects2
   * @return 
   */
  _removeNotInArrayObjects(arrayObjects, arrayObjects2) {

    let removed = false;

    for (var i = 0; i < arrayObjects.length; i++) {
      let found = false;
      for (var j = 0; j < arrayObjects2.length; j++) {
        if (arrayObjects[i].id == arrayObjects2[j].id) {
          found = true;
          break;
        }
      }

      if (!found) {
        arrayObjects.splice(i, 1);
        i--;
        removed = true;
      }

    }

    return removed;

  }


  /**
 * Devuelve el título del evento
 *
 * @param {*} content objeto o ID con el contenido
 * @return string
 */
  renderContentTitle(content, trim = true) {
    if (!content) return;

    // Si es un ID, lo buscamos
    if (typeof content == 'number') {
      content = this.contentGet(content);
    }

    if (content['title_es-ar']) {
      return content['title_es-ar'];
    }

    if (trim) {
      var team_1 = this.getTeamName(content.team_1);

      // Si está vacío leemos el nombre del content
      if (team_1 == '') {
        team_1 = content.team_1_name;
      }

      if (team_1.length > 16) {
        team_1 = team_1.substring(0, 16) + '...';
      }

      var team_2 = this.getTeamName(content.team_2);

      // Si está vacío leemos el nombre del content
      if (team_2 == '') {
        team_2 = content.team_2_name;
      }


      if (team_2.length > 16) {
        team_2 = team_2.substring(0, 16) + '...';
      }
      var title = team_1 + ' - ' + team_2;
      return title;

    }

    var title = this.getTeamName(content.team_1) + ' - ' + this.getTeamName(content.team_2);

    return title;

  }


  /**
   * Devuelve el título del torneo
   * @param {int} tournament id del torneo
   * @return string
   */
  getTournamentName(id) {
    if (!id) return;

    var tournament = this.getTournament(tournament);

    if (!tournament) return;

    return tournament.name;

  }

  /**
   * Devuelve todo el contenido de una competición
   *
   * @param {*} id 
   * @memberof Content
   */
  async getTournamentContent(id) {

    var jsonUrl = this.staticContentUrl + 'static/' + this.brand + '/data/content/tournament/content_tournament_' + id + '.json'

    try {
      var data = await fetch(jsonUrl + '?' + Math.random());
      var data = await data.json();
    } catch (error) { // No se ha encontrado el contenido
      console.warn('[Content] Tournament ' + id + ' content not found');
      return [];
    }

    // Añadimos el contenido al cache
    this.cacheAddData(data);

    return data.d.content;

  }

  /**
   * Devuelve todo el contenido de un equipo
   *
   * @param {*} id 
   * @memberof Content
   */
  async getTeamContent(id) {

    var jsonUrl = this.staticContentUrl + 'static/' + this.brand + '/data/content/team/content_team_' + id + '.json'

    try {
      var data = await fetch(jsonUrl + '?' + Math.random());
      var data = await data.json();
    } catch (error) { // No se ha encontrado el contenido
      console.warn('[Content] Team ' + id + ' content not found');
      return [];
    }

    // Añadimos el contenido al cache
    this.cacheAddData(data);

    return data.d.content;

  }

  async download(id, resolution) {
    var node = await this.self.api.getNode();

    var url = node + '/content/download/' + id + '/' + resolution + '/?user_session=' + this.self.user.current_user.session_hash + '&user_id=' + this.self.user.current_user.id;

    // Abrimos una nueva ventana con la url
    window.open(url, '_blank');

  }

}


